$shm_ba_file_store_list $mol_view
	search? \
	sub /
		<= Head $mol_view
			sub /
				<= Title $mol_view
					sub /
						\Локальные файлы
				<= Summary $mol_view
					sub / <= files_summary \
				<= Delete_all $mol_pick
					align \center
					showed? <=> delete_all_showed? false
					auto /
						^
						<= delete_all_outside_listener null
					trigger_content /
						<= Delete_all_icon $mol_icon_trash_can
						\Удалить все
					bubble_content /
						<= Delete_all_confirm $mol_view
							sub /
								<= Delete_all_text $mol_paragraph
									title \Удалить все локальные файлы?
								<= Delete_all_actions $mol_view
									sub /
										<= Delete_all_yes $mol_button_major
											title \Удалить
											click? <=> delete_all? null
										<= Delete_all_no $mol_button_minor
											title \Отмена
											click? <=> delete_all_cancel? null
		<= Search $mol_string
			hint \Поиск файла или дашборда
			value? <=> search? \
		<= Files $mol_list
			rows <= file_rows /
	File_row* $mol_view
		sub /
			<= File_info* $mol_view
				sub /
					<= File_title* $mol_view
						sub /
							<= file_title* \
					<= File_meta* $mol_view
						sub /
							<= file_meta* \
			<= File_delete* $mol_pick
				align \center
				showed? <=> file_delete_showed*? false
				auto /
					^
					<= file_delete_outside_listener* null
				trigger_content /
					<= File_delete_icon* $mol_icon_trash_can
				bubble_content /
					<= File_delete_bubble* $mol_view
						sub /
							<= File_delete_text* $mol_view
								sub / \Удалить файл?
							<= File_delete_yes* $mol_button_minor
								title \Да
								click? <=> file_delete*? null
							<= File_delete_no* $mol_button_minor
								title \Нет
								click? <=> file_delete_cancel*? null
	Empty $mol_view
		sub /
			<= empty_message \
